import iconAvalancha from "../../../assets/images/parametros/avalancha-escombros.png";
import iconCaida from "../../../assets/images/parametros/caida-piroclastica.png";
import iconCorriente from "../../../assets/images/parametros/corriente-densidad-piroclastica.png";
import iconLahar from "../../../assets/images/parametros/lahar.png";
import iconFlujo from "../../../assets/images/parametros/flujo-lava.png";
import iconGases from "../../../assets/images/parametros/gases-volcanicos.png";
import iconDomo from "../../../assets/images/parametros/domo-lava.png";
import { normalizeTipoParam } from "./paramEruptivosColumns";

export const PARAM_TIPOS_CATALOGO = [
  {
    label: "Avalancha de escombros",
    icon: iconAvalancha,
    normKey: "avalancha de escombros",
    aliases: ["avalancha de escombros"],
  },
  {
    label: "Caída piroclástica",
    icon: iconCaida,
    normKey: "caida piroclastica",
    aliases: ["caida piroclastica", "caída piroclástica"],
  },
  {
    label: "Corriente de densidad piroclástica",
    icon: iconCorriente,
    normKey: "corriente de densidad piroclastica",
    aliases: [
      "corriente de densidad piroclastica",
      "corriente de densidad piroclástica",
    ],
  },
  {
    label: "Lahar",
    icon: iconLahar,
    normKey: "lahar",
    aliases: ["lahar"],
  },
  {
    label: "Flujo de lava",
    icon: iconFlujo,
    normKey: "flujo de lava",
    aliases: ["flujo de lava"],
  },
  {
    label: "Gases volcánicos",
    icon: iconGases,
    normKey: "gases y aerosoles",
    aliases: [
      "gases volcanicos",
      "gases volcánicos",
      "gases y aerosoles",
      "gases aerosoles",
    ],
  },
  {
    label: "Domo de lava",
    icon: iconDomo,
    normKey: "domo de lava",
    aliases: ["domo de lava"],
  },
];

export function getParamCatalogLabel(rawTipo) {
  const norm = normalizeTipoParam(rawTipo);
  if (!norm) return null;

  const match = PARAM_TIPOS_CATALOGO.find((item) =>
    item.aliases.some((alias) => normalizeTipoParam(alias) === norm),
  );

  return match?.label ?? null;
}

export const PRODUCTO_CLAVE_ICON = {
  avalancha_escombros: iconAvalancha,
  caida_piroclastica: iconCaida,
  corriente_densidad_piroclastica: iconCorriente,
  corriente_de_densidad_piroclastica: iconCorriente,
  lahar: iconLahar,
  flujo_lava: iconFlujo,
  gases_volcanicos: iconGases,
  gases_y_aerosoles: iconGases,
  domo_lava: iconDomo,
};

export function getProductoEruptivoIcon(clave, nombre) {
  const key = String(clave ?? "")
    .trim()
    .toLowerCase();
  if (key && PRODUCTO_CLAVE_ICON[key]) return PRODUCTO_CLAVE_ICON[key];

  const label = getParamCatalogLabel(nombre || key.replace(/_/g, " "));
  if (!label) return null;
  return (
    PARAM_TIPOS_CATALOGO.find((item) => item.label === label)?.icon ?? null
  );
}

function getProductoSortIndex(producto) {
  const nombre = String(producto?.nombre ?? "").trim();
  const clave = String(producto?.clave ?? "")
    .trim()
    .replace(/_/g, " ");
  const label = getParamCatalogLabel(nombre || clave);
  if (label) {
    const idx = PARAM_TIPOS_CATALOGO.findIndex((item) => item.label === label);
    if (idx >= 0) return idx;
  }

  const normNombre = normalizeTipoParam(nombre);
  const normClave = normalizeTipoParam(clave);
  const idx = PARAM_TIPOS_CATALOGO.findIndex(
    (item) =>
      normalizeTipoParam(item.normKey) === normNombre ||
      normalizeTipoParam(item.normKey) === normClave ||
      item.aliases.some(
        (alias) =>
          normalizeTipoParam(alias) === normNombre ||
          normalizeTipoParam(alias) === normClave,
      ),
  );
  return idx >= 0 ? idx : 999;
}

/** Más palabras / texto más largo → más abajo (etiquetas de 2–3 líneas al final). */
function getProductoLabelComplexity(producto) {
  const nombre = String(producto?.nombre ?? "").trim();
  const clave = String(producto?.clave ?? "")
    .trim()
    .replace(/_/g, " ");
  const label = getParamCatalogLabel(nombre || clave) || nombre || clave;
  const parts = String(label).split(/\s+/).filter(Boolean);
  return parts.length * 1000 + String(label).length;
}

export function sortProductosEruptivos(productos) {
  return [...productos].sort((a, b) => {
    const byLength =
      getProductoLabelComplexity(a) - getProductoLabelComplexity(b);
    if (byLength !== 0) return byLength;
    return getProductoSortIndex(a) - getProductoSortIndex(b);
  });
}

export function normalizeProductosEruptivosList(gen) {
  const raw = gen?.productos_eruptivos;
  if (Array.isArray(raw) && raw.length > 0) {
    return sortProductosEruptivos(
      raw
        .map((item) => {
          const nombre = String(item?.nombre ?? item?.label ?? "").trim();
          const clave = String(item?.clave ?? "").trim();
          if (!nombre && !clave) return null;
          return {
            clave,
            nombre: nombre || clave.replace(/_/g, " "),
            icon: getProductoEruptivoIcon(clave, nombre),
          };
        })
        .filter(Boolean),
    );
  }

  const texto = String(gen?.productos_eruptivos_texto ?? "").trim();
  if (!texto) return [];

  return sortProductosEruptivos(
    texto
      .split(/[,;]/)
      .map((part) => part.trim())
      .filter(Boolean)
      .map((nombre) => ({
        clave: "",
        nombre,
        icon: getProductoEruptivoIcon("", nombre),
      })),
  );
}

export function getParamTipoNormFromLabel(catalogLabel) {
  const item = PARAM_TIPOS_CATALOGO.find(
    (entry) => entry.label === catalogLabel,
  );
  if (!item) return normalizeTipoParam(catalogLabel);
  return normalizeTipoParam(item.normKey);
}

export function paramBelongsToTipo(row, catalogLabel) {
  const raw = String(row?.tipo_producto_eruptivo ?? "").trim();
  return getParamCatalogLabel(raw) === catalogLabel;
}

export function getParamTiposConDatos(rows) {
  return PARAM_TIPOS_CATALOGO.filter((item) =>
    (rows || []).some((row) => paramBelongsToTipo(row, item.label)),
  );
}
